export const fullSpec = {
  defCodes: [
    'id',
    'driver',
    'configName',
    'configType',
    'startTimestamp',
    'createdAt'
  ],
  columns: [
    {
      t: 'ID|',
      d: 'id',
      w: 80,
      code: 'id',
      sortBy: false,
      selectable: true
    },
    {
      code: 'vehicleCode',
      t: 'Veículo',
      d: 'vehicle.code',
      hint: 'Placa/código do veículo',
      w: 130
    },
    {
      code: 'vehicleAux',
      t: 'Cód. aux.',
      d: 'vehicle.aux',
      hint: 'Código auxiliar do veículo',
      selectable: true
    },
    {
      code: 'vehicleTags',
      t: 'Tags Veic.',
      d: 'vehicle.tags',
      selectable: true,
      hint: 'Tags atuais do veículo'
    },
    {
      code: 'vehicleGroup',
      t: 'Grupo Veic.',
      d: 'vehicle.group',
      hint: 'Grupo do veículo',
      selectable: true
    },
    {
      t: 'Motorista',
      d: 'driver.name',
      sortBy: false,
      code: 'driver'
    },
    {
      code: 'driverTags',
      t: 'Tags Mot.',
      d: 'driver.tags',
      selectable: true,
      hint: 'Tags atuais do motorista'
    },
    {
      code: 'driverGroup',
      t: 'Grupo Mot.',
      d: 'driver.group',
      hint: 'Grupo do motorista',
      selectable: true
    },
    {
      t: 'Ocorrência',
      d: 'config.name',
      sortBy: false,
      code: 'configName',
      selectable: true
    },
    {
      t: 'Tipo',
      d: (row) => {
        if (row.config.type == 'infraction') {
          return { tagColor: 'red', value: 'Infração' }
        } else {
          return { tagColor: 'blue', value: 'Informativa' }
        }
      },
      sortBy: false,
      code: 'configType',
      selectable: true
    },
    {
      t: 'Severidade',
      d: 'config.severity',
      sortBy: false,
      code: 'configSeverity',
      selectable: true
    },

    {
      t: 'Início|',
      d: 'startTimestamp',
      w: 220,
      sortBy: false,
      code: 'startTimestamp',
      selectable: true,
      dataType: 'date',
      format: 'DD/MMM/YYYY HH:mm:ss'
    },

    {
      t: 'Trecho Início|',
      d: 'startTripId',
      sortBy: false,
      code: 'startTripId',
      selectable: true
    },

    {
      t: 'Fim|',
      d: 'endTimestamp',
      w: 220,
      sortBy: false,
      code: 'endTimestamp',
      selectable: true,
      dataType: 'date',
      format: 'DD/MMM/YYYY HH:mm:ss'
    },

    {
      t: 'Criado em|',
      d: 'createdAt',
      w: 220,
      sortBy: false,
      code: 'createdAt',
      selectable: true,
      dataType: 'date',
      format: 'DD/MMM/YYYY HH:mm:ss'
    },

    {
      t: 'Atualizado em|',
      d: 'updatedAt',
      w: 220,
      sortBy: false,
      code: 'updatedAt',
      selectable: true,
      dataType: 'date',
      format: 'DD/MMM/YYYY HH:mm:ss'
    },

    {
      t: 'Duração|',
      d: 'durationSeconds',
      w: 70,
      format: 'sDuration',
      sortBy: false,
      code: 'durationS',
      selectable: true
    }
  ]
}
